import {
  ParticipantLimits,
  ParticipationService
} from 'src/app/features/booking/participation/participation.service'
import { combineLatest, Observable, of } from 'rxjs'
import { catchError, filter, map, take, timeout } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { NotificationService } from 'src/app/core/notification.service'
import { settingSelectors } from 'src/app/core/settings/settings.selectors'
import { bookingSelectors } from 'src/app/features/booking/booking.selectors'
import {
  ParticipantsAdjustmentAction,
  Participation,
  ParticipationType
} from 'src/app/features/booking/participation/participation'
import { participationActions } from 'src/app/features/booking/participation/participation.actions'
import { participationSelectors } from 'src/app/features/booking/participation/participation.selectors'
import { productSelectors } from 'src/app/features/product/product.selectors'
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewChildren
} from '@angular/core'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { SaleItem } from '../sale-item'
import { saleItemActions } from '../sale-item.actions'
import { saleItemSelectors } from '../sale-item.selectors'
import { environment } from 'src/environments/environment'
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import { CancellationPolicy } from 'src/app/shared/interfaces'
import { configurationOptionSelectors } from 'src/app/features/configuration-option/configuration-option.selectors'
import { Booking } from 'src/app/features/booking/booking'
import { getEnumAsArray } from 'src/app/shared/until'
import { Product } from 'src/app/features/product/product'
import { Dictionary } from '@ngrx/entity'
import { UntilDestroy } from '@ngneat/until-destroy'
import { memberSelectors } from 'src/app/features/member/member.selectors'
import { Member } from 'src/app/features/member/member'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { memberActions } from 'src/app/features/member/member.actions'
import { TranslateService } from '@ngx-translate/core'

interface ParticipationCountsByResource {
  participantLimits: ParticipantLimits
  activity: number
  resourceId: number
  description: string
  currentNumberOfParticipants: number
  adjustedNumberOfParticipants: number
  maxNumberOfParticipants: number
  bookingId?: number
  calculatedDarticipants?: number
}
@UntilDestroy()
@Component({
  selector: 'sale-item-adjust-participations-by-type',
  templateUrl: './sale-item-adjust-participations-by-type.component.html',
  styleUrls: ['./sale-item-adjust-participations-by-type.component.scss']
})
export class SaleItemAdjustParticipationsByTypeComponent implements OnInit {
  @Input() type: ParticipationType
  @Input() saleItem: SaleItem
  @Input() participantsLimits: ParticipantLimits

  @Output() haveVisibleFather = new EventEmitter<any>()

  @ViewChild('addToogleButton')
  addToogleButton: ElementRef
  @ViewChildren('numberOfParticipants')
  numberOfParticipants: ElementRef
  public showCancellationPolciy: boolean = false
  public title: string
  public isAdjustFormVisible: boolean = false
  public overWritePartcipants: Map<ParticipationType, boolean> = new Map()
  private numberOfParticipantsWithDifferentType: number = 0
  public participationType = getEnumAsArray(ParticipationType)
  public form: UntypedFormGroup
  public formInvitedMembersMail: UntypedFormGroup
  public productEntities$ = this.store.select(productSelectors.selectEntities)
  public bookingEntities$ = this.store.select(bookingSelectors.selectEntities)
  public participation$ = this.store.select(participationSelectors.selectAll)
  public cancellationPolicies$: Observable<CancellationPolicy[]>
  public selectedLanguage$: Observable<string>
  public participationCountsByResource: ParticipationCountsByResource[] = []
  public members$: Observable<Member[]>

  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private fb: UntypedFormBuilder,
    private notificationService: NotificationService,
    private participationService: ParticipationService,
    private translate: TranslateService
  ) {}
  get invitedMemberMail() {
    return this.formInvitedMembersMail.controls[
      'invitedMembersMail'
    ] as UntypedFormArray
  }

  addInvitedMemberMail() {
    this.invitedMemberMail.push(
      this.fb.group({
        email: [null, [Validators.required]]
      })
    )
  }
  removeInvitedMemberMail(index: number, idx: number) {
    this.invitedMemberMail.removeAt(idx)
    this.participationCountsByResource[index].adjustedNumberOfParticipants =
      this.invitedMemberMail.length == 0 ? 0 : this.invitedMemberMail.length
    if (this.invitedMemberMail.length == 0) {
      this.invitedMemberMail.clear()
    }
  }
  get typeOfGuestParticipation() {
    return this.participationType.find((item) => item.key == 'guest').value
  }

  ngOnInit() {
    this.form = this.fb.group({
      cancelationPolicyUuid: [null, []],
      numberOfParticipants: []
    })
    this.formInvitedMembersMail = this.fb.group({
      invitedMembersMail: this.fb.array([])
    })
    this.members$ = this.store.select(memberSelectors.selectAll)
    this.selectedLanguage$ = this.store.select(
      settingSelectors.selectById,
      'language'
    )
    this.cancellationPolicies$ = this.store
      .select(configurationOptionSelectors.selectByKey, 'cancellation_policies')
      .pipe(
        filter((x) => Boolean(x)),
        map((configOption) => {
          const policies: CancellationPolicy[] = JSON.parse(configOption.value)

          return policies
        })
      )

    this.initValues()

    switch (this.type) {
      case ParticipationType.GUEST:
        this.title = 'bookingModule.guests'
        break
      case ParticipationType.MEMBER:
        this.title = 'bookingModule.members'
        break
      case ParticipationType.OTHER:
        this.title = 'bookingModule.supervisors'
        break
    }
  }
  public onSearchMembers(term: string): void {
    this.store.dispatch(
      memberActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: {
            $or: [
              {
                firstName: {
                  [CondOperator.CONTAINS_LOW]: term
                }
              },
              {
                email: {
                  [CondOperator.CONTAINS_LOW]: term
                }
              },
              {
                lastName: {
                  [CondOperator.CONTAINS_LOW]: term
                }
              }
            ]
          },
          join: [
            { field: 'userRoles' },
            { field: 'userRoles.organization' },
            { field: 'subscribers' }
          ]
        })
      })
    )
  }
  public sendTheNewValue(newValue, idx) {
    if (newValue?.target?.value) this.setValues(newValue, idx)
  }
  public getMaxParticipants$(participantCount) {
    return combineLatest([
      of(this.saleItem),
      this.store.select(productSelectors.selectEntities),
      this.store.select(bookingSelectors.selectEntities),
      this.store.select(participationSelectors.selectAll)
    ]).pipe(
      take(1),
      map(([saleItem, productEntities, bookingEntities, participations]) => {
        let participantTypeCount: number
        let saleItemParticipationsByType: number = 0
        let saleItemParticipations: number = 0
        let maxParticipants = this.participantsLimits['maxParticipants']
        const booking = saleItem?.bookingId
          ? bookingEntities[saleItem.bookingId]
          : null
        if (booking?.id) {
          const saleItemParticipation = participations.filter(
            (p) => p.bookingId == booking.id
          )
          if (
            booking.hasOwnProperty('currentParticipantCount') &&
            booking.hasOwnProperty('availableParticipantCount') &&
            booking.currentParticipantCount != null &&
            booking.availableParticipantCount != null
          ) {
            maxParticipants =
              booking.currentParticipantCount +
              booking.availableParticipantCount
          }
          saleItemParticipations = saleItemParticipation.length
          saleItemParticipationsByType = saleItemParticipation.filter(
            (p) => p.type == this.type
          ).length
        }
        const product = productEntities[saleItem.productId]
        const bookerMustBeParticipant = product?.bookerMustBeParticipant ? 1 : 0
        const spotsLeft = maxParticipants - saleItemParticipations

        switch (this.type) {
          case ParticipationType.GUEST:
            participantTypeCount = Math.min(
              this.participantsLimits['maxGuestInvites'],
              this.participantsLimits.maxParticipants
            )

            break
          case ParticipationType.OTHER:
            participantTypeCount = Math.min(
              this.participantsLimits['maxOtherInvites'],
              this.participantsLimits.maxParticipants
            )

            break
          case ParticipationType.MEMBER:
            participantTypeCount = Math.min(
              this.participantsLimits['maxMemberInvites'],
              this.participantsLimits.maxParticipants
            )

            break
        }
        const calculatedParticipants = this.participantsLimits
          ? Math.abs(participantTypeCount)
          : participantCount.maxNumberOfParticipants

        this.participationCountsByResource.map((item) => {
          if (
            item.activity == participantCount.activity &&
            item.resourceId == participantCount.resourceId &&
            item.bookingId == participantCount.bookingId
          ) {
            item.calculatedDarticipants = calculatedParticipants
          }
        })

        return calculatedParticipants
      })
    )
  }
  public showAddMoreButton(
    totalCurrentParticipants: any,
    participationCountsByResource: ParticipationCountsByResource[],
    productEntities: Dictionary<Product>,
    bookingEntities: Dictionary<Booking>,
    participations: Participation[]
  ) {
    if (!this.saleItem && this.saleItem.bookingId && this.saleItem.productId)
      return false

    const participantCount = participationCountsByResource.find(
      (item) =>
        item.activity == this.saleItem.productId &&
        item.bookingId == this.saleItem.bookingId
    )

    if (!participantCount) return false
    const booking = bookingEntities[this.saleItem.bookingId]
    const product = productEntities[this.saleItem.productId]
    if (!booking && !product) return
    let saleItemParticipationsByType: number = 0
    let saleItemParticipations: number = 0
    let maxParticipants = this.participantsLimits['maxParticipants']
    if (booking?.id) {
      const saleItemParticipation = participations.filter(
        (p) => p.bookingId == booking.id
      )
      if (
        booking.hasOwnProperty('currentParticipantCount') &&
        booking.hasOwnProperty('availableParticipantCount') &&
        booking.currentParticipantCount != null &&
        booking.availableParticipantCount != null
      ) {
        maxParticipants =
          booking.currentParticipantCount + booking.availableParticipantCount
      }
      saleItemParticipations = saleItemParticipation.length
      saleItemParticipationsByType = saleItemParticipation.filter(
        (p) => p.type == this.type
      ).length
    }
    const spotsLeft = maxParticipants - saleItemParticipations
    const bookerMustBeParticipant = product?.bookerMustBeParticipant ? 1 : 0
    let maxParticipantsByType = 0
    let show = false
    switch (this.type) {
      case ParticipationType.GUEST:
        show =
          participantCount.adjustedNumberOfParticipants >
            participantCount.participantLimits.maxGuestInvites ||
          participantCount.adjustedNumberOfParticipants >
            participantCount.calculatedDarticipants
        // maxParticipantsByType =
        //   Math.min(
        //     participantCount.participantLimits.maxGuestInvites,
        //     spotsLeft
        //   ) - participantCount.currentNumberOfParticipants
        break
      case ParticipationType.OTHER:
        show =
          participantCount.adjustedNumberOfParticipants >
            participantCount.participantLimits.maxOtherInvites ||
          participantCount.adjustedNumberOfParticipants >
            participantCount.calculatedDarticipants
        // maxParticipantsByType =
        //   Math.min(
        //     participantCount.participantLimits.maxOtherInvites,
        //     spotsLeft
        //   ) - participantCount.currentNumberOfParticipants
        break
      case ParticipationType.MEMBER:
        show =
          participantCount.adjustedNumberOfParticipants >
            participantCount.participantLimits.maxMemberInvites ||
          participantCount.adjustedNumberOfParticipants >
            participantCount.calculatedDarticipants
        // maxParticipantsByType =
        //   Math.min(
        //     participantCount.participantLimits.maxMemberInvites,
        //     spotsLeft
        //   ) - participantCount.currentNumberOfParticipants
        break
    }
    //  show =
    //   participantCount.adjustedNumberOfParticipants >=
    //     maxParticipantsByType + participantCount.currentNumberOfParticipants ||
    //   participantCount.adjustedNumberOfParticipants >=
    //     participantCount.calculatedDarticipants
    // if (!show) {
    //   this.onToggleOverWrite(this.type, participationCountsByResource, show)
    // }
    return show
  }
  public onToggleOverWrite(
    participantsType: ParticipationType,
    participationCountsByResource: ParticipationCountsByResource[],
    targetValue: boolean
  ) {
    if (targetValue) this.showAdjustForm(participantsType)
    if (!targetValue) this.closeInput(participantsType)
    if (!this.saleItem && this.saleItem.bookingId && this.saleItem.productId)
      return
    const participantCount = participationCountsByResource.find(
      (item) =>
        item.activity == this.saleItem.productId &&
        item.bookingId == this.saleItem.bookingId
    )
    if (!participantCount) return false
    this.overWritePartcipants.set(participantsType, targetValue)

    if (
      !targetValue &&
      this.numberOfParticipants &&
      this.addToogleButton &&
      !this.addToogleButton.nativeElement.checked
    ) {
      combineLatest([
        this.store.select(productSelectors.selectEntities),
        this.store.select(bookingSelectors.selectEntities)
      ])
        .pipe(take(1))
        .subscribe(([productEntities, bookingEntities]) => {
          const booking = bookingEntities[participantCount?.bookingId]
          const product = productEntities[booking?.productId]
          if (!booking && !product) return

          const bookerMustBeParticipant = product?.bookerMustBeParticipant
            ? 1
            : 0
          if (this.numberOfParticipants.nativeElement)
            this.numberOfParticipants.nativeElement.value =
              participantCount.participantLimits.maxGuestInvites -
              bookerMustBeParticipant
        })
    }
  }
  public showAdjustForm(participantsType) {
    this.isAdjustFormVisible = true
    this.overWritePartcipants.set(participantsType, true)
  }
  public getValues(i) {
    return this.participationCountsByResource[i].adjustedNumberOfParticipants
  }
  public setValues(event, idx) {
    if (!event || !event?.target?.value) return
    if (
      Number(event.target.value) < 0 ||
      Number(event.target.value) ==
        Number(
          this.participationCountsByResource[idx].adjustedNumberOfParticipants
        )
    ) {
      return
    }
    let diffAmount =
      Number(event.target.value) -
      Number(
        this.participationCountsByResource[idx].adjustedNumberOfParticipants
      )

    combineLatest([
      this.getNumberOfParticipantsPart$(),
      this.productEntities$,
      this.bookingEntities$,
      this.participation$,
      this.getMaxParticipants$(this.participationCountsByResource[idx])
    ])
      .pipe(take(1))
      .subscribe(
        ([
          numOfParticipants,
          productEntities,
          bookingEntities,
          participation,
          maxParticipants
        ]) => {
          let provisionalParticipationCountsByResource =
            this.participationCountsByResource
          provisionalParticipationCountsByResource[
            idx
          ].adjustedNumberOfParticipants = event.target.value
          if (
            this.showAddMoreButton(
              numOfParticipants,
              provisionalParticipationCountsByResource,
              productEntities,
              bookingEntities,
              participation
            ) &&
            !this.overWritePartcipants.get(this.type) &&
            this.type == ParticipationType.MEMBER
          ) {
            this.participationCountsByResource[
              idx
            ].adjustedNumberOfParticipants = maxParticipants
            if (Number(event.target.value) > maxParticipants) {
              this.invitedMemberMail.clear()
              for (let i = 0; i < Math.abs(maxParticipants); i++) {
                this.addInvitedMemberMail()
              }
            } else if (Number(event.target.value) == maxParticipants) {
              for (let i = 0; i < Math.abs(diffAmount); i++) {
                this.addInvitedMemberMail()
              }
            }

            return
          }
          this.participationCountsByResource[idx].adjustedNumberOfParticipants =
            event.target.value
          if (diffAmount > 0 && this.type == ParticipationType.MEMBER) {
            for (let i = 0; i < Math.abs(diffAmount); i++) {
              this.addInvitedMemberMail()
            }
          } else if (diffAmount < 0 && this.invitedMemberMail.length) {
            for (let i = 0; i < Math.abs(diffAmount); i++) {
              this.removeInvitedMemberMail(idx, i)
            }
          } else if (
            diffAmount < 0 &&
            (!this.invitedMemberMail?.length ||
              this.invitedMemberMail?.length == 0) &&
            this.type == ParticipationType.MEMBER
          ) {
            this.showCancellationPolciy = this.showCancellationPolciyField()
          }
        }
      )
  }
  public initValues() {
    this.participationCountsByResource = []
    combineLatest([
      this.store.select(participationSelectors.selectAll),
      this.store.select(bookingSelectors.selectAll),
      this.store.select(productSelectors.selectAll)
    ])
      .pipe(take(1))
      .subscribe(([participations, bookings, products]) => {
        const saleItemParticipations = participations.filter(
          (p) => p.saleItemId == this.saleItem.id
        )

        const saleItemParticipationsByType = saleItemParticipations.filter(
          (p) => p.type == this.type
        )

        this.numberOfParticipantsWithDifferentType =
          saleItemParticipations?.length - saleItemParticipationsByType.length

        const saleItemBookingIds = [
          ...new Set(saleItemParticipationsByType.map((p) => p.bookingId))
        ]

        const saleItemBookings = bookings.filter((booking) =>
          saleItemBookingIds.includes(booking.id)
        )

        const saleItemResourceIds = saleItemBookings.map(
          (booking) => booking.productId
        )

        const saleItemResources = products.filter((product) =>
          saleItemResourceIds.includes(product.id)
        )
        if (saleItemResourceIds.length == 0) {
          const booking = bookings.find((b) => b.id == this.saleItem?.bookingId)
          const resource = products.find((p) => p.id == booking?.productId)
          if (resource && booking) {
            const activity = products.find(
              (item) => item.id == booking.linkedProductId
            )
            let maxNumberOfParticipants = 0
            let participantLimits: ParticipantLimits
            let bookerMustBeParticipant = 0
            participantLimits =
              this.participationService.calculateParticipantLimits(
                resource,
                activity,
                booking.maxParticipants
              )
            bookerMustBeParticipant = activity.bookerMustBeParticipant ? 1 : 0
            switch (this.type) {
              case ParticipationType.GUEST:
                maxNumberOfParticipants = participantLimits
                  ? Math.max(
                      participantLimits?.maxGuestInvites,
                      participantLimits?.maxParticipants
                    )
                  : (resource.maxGuestInvites ?? resource.maxParticipants ?? 0)
                maxNumberOfParticipants =
                  maxNumberOfParticipants - bookerMustBeParticipant > 0
                    ? maxNumberOfParticipants - bookerMustBeParticipant
                    : 0
                break
              case ParticipationType.OTHER:
                maxNumberOfParticipants = participantLimits
                  ? Math.max(
                      participantLimits?.maxOtherInvites,
                      participantLimits?.maxParticipants
                    )
                  : (resource.maxOtherInvites ?? resource.maxParticipants ?? 0)
                break
              case ParticipationType.MEMBER:
                maxNumberOfParticipants = participantLimits
                  ? Math.max(
                      participantLimits?.maxMemberInvites,
                      participantLimits?.maxParticipants
                    )
                  : (resource.maxMemberInvites ?? resource.maxParticipants ?? 0)
                break
              default:
                maxNumberOfParticipants =
                  participantLimits?.maxParticipants ??
                  resource.maxParticipants ??
                  0
            }
            this.participationCountsByResource.push({
              resourceId: resource.id,
              participantLimits,
              activity: activity.id,
              description: resource.description,
              currentNumberOfParticipants: 0,
              adjustedNumberOfParticipants: 0,
              maxNumberOfParticipants,
              bookingId: booking?.id ?? null
            })
          }
        }
        for (const resourceId of saleItemResourceIds) {
          const resource = saleItemResources.find((p) => p.id == resourceId)
          if (!resource) {
            continue
          }

          const numberofParticipants =
            saleItemParticipationsByType.filter((p) => {
              const booking = saleItemBookings.find((b) => b.id == p.bookingId)
              return booking.productId == resourceId
            }).length ?? 0

          if (numberofParticipants == 0) {
            continue
          }

          let maxNumberOfParticipants = 0
          let participantLimits: ParticipantLimits
          const booking = saleItemBookings.find(
            (b) => b.productId == resourceId
          )
          let bookerMustBeParticipant = 0
          let activity
          if (booking) {
            activity = products.find(
              (item) => item.id == booking.linkedProductId
            )

            participantLimits =
              this.participationService.calculateParticipantLimits(
                resource,
                activity,
                booking.maxParticipants
              )
            bookerMustBeParticipant = activity.bookerMustBeParticipant ? 1 : 0
          }

          switch (this.type) {
            case ParticipationType.GUEST:
              maxNumberOfParticipants = participantLimits
                ? Math.max(
                    participantLimits?.maxGuestInvites,
                    participantLimits?.maxParticipants
                  )
                : (resource.maxGuestInvites ?? resource.maxParticipants ?? 0)
              maxNumberOfParticipants =
                maxNumberOfParticipants - bookerMustBeParticipant > 0
                  ? maxNumberOfParticipants - bookerMustBeParticipant
                  : 0
              break
            case ParticipationType.OTHER:
              maxNumberOfParticipants = participantLimits
                ? Math.max(
                    participantLimits?.maxOtherInvites,
                    participantLimits?.maxParticipants
                  )
                : (resource.maxOtherInvites ?? resource.maxParticipants ?? 0)
              break
            case ParticipationType.MEMBER:
              maxNumberOfParticipants = participantLimits
                ? Math.max(
                    participantLimits?.maxMemberInvites,
                    participantLimits?.maxParticipants
                  )
                : (resource.maxMemberInvites ?? resource.maxParticipants ?? 0)
              break
            default:
              maxNumberOfParticipants =
                participantLimits?.maxParticipants ??
                resource.maxParticipants ??
                0
          }

          const resourceBookings = saleItemBookings.filter(
            (booking) => booking.productId == resourceId
          )

          this.participationCountsByResource.push({
            resourceId,
            participantLimits,
            activity: activity.id,
            description: resource.description,
            currentNumberOfParticipants: numberofParticipants,
            adjustedNumberOfParticipants: numberofParticipants,
            maxNumberOfParticipants,
            bookingId: resourceBookings[0]?.id ?? null
          })
        }
      })
  }

  public closeInput(participantsType) {
    this.initValues()
    this.isAdjustFormVisible = false

    if (this.type == ParticipationType.MEMBER) {
      this.invitedMemberMail.clear()
    }
    this.overWritePartcipants.set(participantsType, false)
  }
  public hideAdjustForm() {
    this.isAdjustFormVisible = false

    if (this.type == ParticipationType.MEMBER) {
      this.invitedMemberMail.clear()
    }
    this.haveVisibleFather.emit(this.isAdjustFormVisible)
  }

  public onAdjustNumberOfParticipants() {
    const adjustments = this.participationCountsByResource.filter(
      (pc) => pc.adjustedNumberOfParticipants != pc.currentNumberOfParticipants
    )

    if (adjustments.length == 0) {
      console.warn('Cannot adjust participants as no changes were made')
      return
    }

    const isThereResourceWithParticipantsLeft =
      this.participationCountsByResource.some(
        (pc) => pc.adjustedNumberOfParticipants > 0
      )

    if (
      !isThereResourceWithParticipantsLeft &&
      this.numberOfParticipantsWithDifferentType == 0
    ) {
      this.notificationService.emit(
        'saleItemModule.pleaseDeleteSaleItem',
        'warning'
      )
      return
    }

    const cancelationPolicyUuid = this.form.value.cancelationPolicyUuid ?? null

    if (this.showCancellationPolciyField() && !cancelationPolicyUuid) {
      // TODO: mark cancellation policy field as invalid
      this.notificationService.emit(
        'organizeBookingsModule.needToSelectCancellationPolicy',
        'warning'
      )
      return false
    }

    if (
      this.type == ParticipationType.MEMBER &&
      !this.formInvitedMembersMail.valid
    ) {
      this.notificationService.emit('alerts.missingRequiredFields', 'warning')
      return
    } else if (
      this.type == ParticipationType.MEMBER &&
      this.formInvitedMembersMail.valid &&
      this.formInvitedMembersMail.value.invitedMembersMail?.length &&
      this.formInvitedMembersMail.value.invitedMembersMail?.length > 0
    ) {
      let duplicateItem: boolean = false
      this.formInvitedMembersMail.value.invitedMembersMail.reduce(
        (acc, member) => {
          if (!acc[member.email]) {
            acc[member.email] = []
          } else {
            duplicateItem = true
          }

          acc[member.email].push(member)

          return acc
        },
        {}
      )

      if (duplicateItem) {
        this.notificationService.emit('general.duplicateMembers', 'warning')
        return
      }
    }

    const confirmMessage = this.translate.instant('general.saveChanges')
    if (!confirm(confirmMessage)) {
      return
    }

    const participantRows = []

    combineLatest([
      this.store.select(participationSelectors.selectAll),
      this.store.select(bookingSelectors.selectAll),
      this.store.select(productSelectors.selectEntities),
      this.store.select(memberSelectors.selectEntities)
    ])
      .pipe(take(1))
      .subscribe(
        ([participations, bookings, productEntities, membersEntities]) => {
          const saleItemParticipationIds = participations
            .filter(
              (participation) =>
                participation.saleItemId == this.saleItem.id &&
                participation.type == this.type
            )
            .filter(Boolean)
          const participationsToDelete = []
          if (
            this.type == ParticipationType.MEMBER &&
            this.formInvitedMembersMail.valid &&
            this.formInvitedMembersMail.value.invitedMembersMail?.length &&
            this.formInvitedMembersMail.value.invitedMembersMail?.length > 0 &&
            this.saleItem.params.invitedMemberEmails?.length &&
            this.saleItem.params.invitedMemberEmails?.length > 0
          ) {
            let duplicateItem: boolean = false
            const emailArray =
              this.formInvitedMembersMail.value?.invitedMembersMail?.map(
                (item) => membersEntities[item.email].email
              )
            Object.values(this.saleItem.params.invitedMemberEmails).forEach(
              (item) => {
                if (
                  emailArray.find((email) => email == JSON.parse(item)?.email)
                ) {
                  duplicateItem = true
                }
              }
            )
            if (duplicateItem) {
              this.notificationService.emit(
                'general.duplicateMembers',
                'warning'
              )
              return
            }
          }

          for (const adjustment of adjustments) {
            const diffAmount =
              adjustment.adjustedNumberOfParticipants -
              adjustment.currentNumberOfParticipants
            if (
              adjustment.calculatedDarticipants &&
              adjustment.adjustedNumberOfParticipants >
                adjustment.calculatedDarticipants &&
              !this.overWritePartcipants.get(this.type)
            ) {
              this.notificationService.emit(
                `Could not create participant adjustment max ${adjustment.calculatedDarticipants}`,
                'warning'
              )
              continue
            }
            if (diffAmount < 0) {
              const bookingParticipations = participations
                .filter(
                  (participation) =>
                    participation.saleItemId == this.saleItem.id &&
                    participation.bookingId == adjustment.bookingId &&
                    participation.type == this.type
                )
                .filter(Boolean)
                .map((participation) => participation.id)

              for (let i = 0; i < Math.abs(diffAmount); i++) {
                participantRows.push({
                  participationId: bookingParticipations[i],
                  email:
                    this.type == ParticipationType.MEMBER
                      ? (this.invitedMemberMail.at(i)?.value?.email ?? null)
                      : null,
                  action: ParticipantsAdjustmentAction.DELETE
                })

                participationsToDelete.push(bookingParticipations[i])
              }
            } else {
              const booking = bookings.find(
                (booking) => booking.id == adjustment.bookingId
              )
              for (let i = 0; i < Math.abs(diffAmount); i++) {
                participantRows.push({
                  type: this.type ?? ParticipationType.GUEST,
                  action: ParticipantsAdjustmentAction.ADD,
                  email:
                    this.type == ParticipationType.MEMBER
                      ? (membersEntities[
                          this.invitedMemberMail.at(i)?.value?.email
                        ]?.email ?? null)
                      : null,
                  customerCategory:
                    productEntities[booking?.linkedProductId]
                      ?.allowChooseCategory && this.saleItem?.customerCategory
                      ? this.saleItem?.customerCategory
                      : null,
                  allowChooseCategory: booking?.linkedProductId
                    ? productEntities[booking?.linkedProductId]
                        ?.allowChooseCategory
                    : null,
                  targetLinkedProductId: booking?.linkedProductId ?? null,
                  targetProductId: adjustment.resourceId ?? null,
                  destinationBookingId: adjustment.bookingId
                })
              }
            }
          }

          if (participantRows.length === 0) {
            console.warn('Could not create participant adjustment rows')
            return
          }

          this.store.dispatch(
            saleItemActions.updateOneBySaleId({
              saleId: this.saleItem.saleId,
              saleLine: this.saleItem.saleLine,
              params: {
                ...this.saleItem,
                cancelationPolicyUuid,
                participantsAdjustment: {
                  participantRows
                }
              }
            })
          )

          this.actions$
            .pipe(
              ofType(saleItemActions.upsertOne, saleItemActions.upsertMany),
              timeout(5000),
              take(1),
              catchError((error) => of(null))
            )
            .subscribe((action) => {
              if (!action) {
                return
              }

              this.notificationService.emit('alerts.success', 'success')

              this.hideAdjustForm()

              if (participationsToDelete.length > 0) {
                this.store.dispatch(
                  participationActions.removeMany({
                    ids: participationsToDelete
                  })
                )
              }
            })
        }
      )
  }

  public getNumberOfParticipantsPart$(): Observable<number> {
    return this.getParticipationsCount$().pipe(
      map((participationsCount) => {
        if (!participationsCount) {
          return 0
        }

        switch (this.type) {
          case ParticipationType.GUEST:
            return participationsCount.participantsGuests ?? 0
            break
          case ParticipationType.MEMBER:
            return participationsCount.participantsMembers ?? 0
            break
          case ParticipationType.OTHER:
            return participationsCount.participantsOthers ?? 0
            break
          default:
            return 0
        }
      })
    )
  }
  public invitedMembersFormGroupAt(i: number) {
    return this.invitedMemberMail.at(i) as UntypedFormGroup
  }
  private getParticipationsCount$(): Observable<{
    participantsGuests: number
    participantsMembers: number
    participantsOthers: number
  }> {
    return combineLatest([
      this.store.select(participationSelectors.selectByFilter, {
        field: 'saleItemId',
        value: this.saleItem.id
      }),
      this.store.select(saleItemSelectors.selectPartials)
    ]).pipe(
      map(([participations, saleItemPartials]): any => {
        const partialFilterds = saleItemPartials
          .filter((p) => p.id == this.saleItem.id)
          .map((partial) => partial.params)

        if (!participations?.length && !partialFilterds?.length) {
          return {
            participantsGuests: 0,
            participantsMembers: 0,
            participantsOthers: 0
          }
        }

        let participantsGuests = 0
        let participantsMembers = 0
        let participantsOthers = 0

        if (partialFilterds?.length) {
          partialFilterds.map((partial) => {
            participantsGuests += partial.invitedGuests?.length
            participantsOthers += partial.invitedOthers?.length
            participantsMembers += partial.invitedMemberEmails?.length
          })
        }

        if (participations?.length) {
          participantsGuests += participations.filter(
            (participation) => participation.type == ParticipationType.GUEST
          )?.length

          participantsOthers += participations.filter(
            (participation) => participation.type == ParticipationType.OTHER
          )?.length

          participantsMembers += participations.filter(
            (participation) => participation.type == ParticipationType.MEMBER
          )?.length
        }

        return {
          participantsGuests: participantsGuests ?? 0,
          participantsMembers: participantsMembers ?? 0,
          participantsOthers: participantsOthers ?? 0
        }
      })
    )
  }

  public isParticipantCountChanged(): boolean {
    return !this.participationCountsByResource.some(
      (pc) => pc.adjustedNumberOfParticipants != pc.currentNumberOfParticipants
    )
  }

  public showCancellationPolciyField(): boolean {
    if (!environment.moduleConfigs.saleModule.cancelationPolicy) {
      return false
    }

    const deletingAdjustment = this.participationCountsByResource.some(
      (pc) => pc.adjustedNumberOfParticipants < pc.currentNumberOfParticipants
    )

    if (!deletingAdjustment) {
      this.form.controls.cancelationPolicyUuid.setValue(null)
      return false
    }

    return true
  }
}
